import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={16}
    height={22}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.4} fillRule="evenodd" clipRule="evenodd" fill="#000">
      <path d="M4.234 2.116a2.116 2.116 0 1 1-4.232 0 2.116 2.116 0 0 1 4.232 0ZM15.002 2.116a2.116 2.116 0 1 1-4.232 0 2.116 2.116 0 0 1 4.232 0ZM4.234 10.73a2.116 2.116 0 1 1-4.232 0 2.116 2.116 0 0 1 4.232 0ZM15.002 10.73a2.116 2.116 0 1 1-4.232 0 2.116 2.116 0 0 1 4.232 0ZM4.234 19.315a2.116 2.116 0 1 1-4.232 0 2.116 2.116 0 0 1 4.232 0ZM15.002 19.315a2.116 2.116 0 1 1-4.232 0 2.116 2.116 0 0 1 4.232 0Z" />
    </g>
  </svg>
);

export default SvgComponent;
